export const socialsData = {
    github: 'https://github.com/koshike-saikumar',
    //facebook: 'https://www.facebook.com/',
    linkedIn: 'https://www.linkedin.com/in/koshike-saikumar',
    instagram: 'https://www.instagram.com/koshike_saikumar/',
   // codepen: 'https://codepen.io/',
   // twitter: 'https://twitter.com/',
    //reddit: 'https://www.reddit.com/user/',
   // blogger: 'https://www.blogger.com/',
    //medium: 'https://medium.com/@',
    //stackOverflow: 'https://stackoverflow.com/users/',
   // gitlab: 'https://gitlab.com/',
    youtube: 'https://www.youtube.com/@saikumarkoshike1367'
}